import { useDialog } from '@/hooks/useDialog';
import { PatientStackParamList } from '@/navigations/PatientStack';
import { useNavigation } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';
import { View } from 'react-native';
import { Text } from '@/components/Text';

export const NoPermission = () => {
  const { removeDialog } = useDialog();
  const { navigate } =
    useNavigation<StackNavigationProp<PatientStackParamList>>();

  const onLinkPress = () => {
    removeDialog();
    navigate('DigaCodes');
  };

  return (
    <View className="p-4">
      <Text className="text-xl">
        Aufgaben können nicht gestartet werden, weil Ihr neolexon Zugang
        abgelaufen ist. Wenn Sie einen Rezeptcode von Ihrer Krankenkasse haben,
        können Sie diesen{' '}
        <Text onPress={onLinkPress} className="text-blue-800">
          hier
        </Text>{' '}
        einlösen.
      </Text>
    </View>
  );
};
